const valueOrEmpty = (value) => value ?? "";

export function mapVerkaufToDialogRow(verkauf) {
  return {
    id: verkauf.v_id,
    kunde_id: valueOrEmpty(verkauf.k_id),
    datum: valueOrEmpty(verkauf.v_datum),
    menge: valueOrEmpty(verkauf.v_menge),
    einheit: valueOrEmpty(verkauf.v_einheit),
    preis: valueOrEmpty(verkauf.v_preis),
    betrag: valueOrEmpty(verkauf.v_betrag),
    bezahlt: verkauf.v_bezahlt === true || verkauf.v_bezahlt === 1 || verkauf.v_bezahlt === "1",
    bemerkung: valueOrEmpty(verkauf.v_bemerkung)
  };
}

export const getVerkaufWildart = (verkauf) => valueOrEmpty(verkauf.w_name);
export const getVerkaufAltersklasse = (verkauf) => valueOrEmpty(verkauf.w_altersklasse);
export const getStreckeAltersklasse = (strecke) => valueOrEmpty(strecke.Altersklasse);
